interface MapOptions {
  lat: number;
  lng: number;
  zoom: number;
}

declare global {
  interface Window {
    initMap: () => void;
    mapData: {
      customIconUrl: string;
    };
  }
}

class BlockMap {
  constructor() {
    window.initMap = this._init.bind(this);
  }


  _init() {
    const maps = document.querySelectorAll(".map") as NodeListOf<HTMLDivElement>;
    if (maps) {
      maps.forEach(async map => {
        const mapElement = map.querySelector(".map__map") as HTMLElement;

        if (!mapElement) return;

        // Récupérer les coordonnées et le zoom depuis l'attribut data-*
        const lat = parseFloat(mapElement.getAttribute("data-lat") || "0");
        const lng = parseFloat(mapElement.getAttribute("data-lng") || "0");

        const position: google.maps.LatLngLiteral = { lat, lng };

        // Charger dynamiquement les bibliothèques "maps" et "marker"
        const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

        // Initialiser la carte
        const iconImg = document.createElement('img');
        iconImg.src = window.mapData?.customIconUrl;;

        const googleMap = new Map(mapElement, {
          zoom: 15,
          center: position,
          mapId: 'Carte',
        });

        // Ajouter un marqueur personnalisé
        const marker = new AdvancedMarkerElement({
          map: googleMap,
          position: position,
          content: iconImg,
        });
      })
    }
  }
}

export const blockMap = new BlockMap();
